import { apiManager } from "../api-manager";

export const checkState = async (state: string) => {
  const res = await apiManager.post("/states/compare", {
    state: state,
  });
  return res;
};

export const findADriver = async (data: {
  lat: number;
  lng: number;
  state: string;
  scheduleTime?: string;
}) => {
  const resp: any = await apiManager.post("/services/nearby-driver", {
    lat: data?.lat,
    lng: data?.lng,
    scheduleTime: data?.scheduleTime ?? null,
    state: data?.state,
  });
  return resp;
};

export const calculateCost = async (data: {
  serviceType: string;
  pickupLat: number;
  pickupLon: number;
  deliveryLat: number;
  deliveryLon: number;
  maxDistance?: number;
  promoCode?: string;
  availedOfferId?: string;
  scheduledTime?: string;
  isCreditsEnabled?: boolean;
}) => {
  const resp = await apiManager.post("/services/calculate-cost", data);
  return resp;
};

export type PickupOrderPayload = {
  serviceMeta: {
    deliveryInstruction: string;
    deliveryLocation: {
      address: string; //
      city: string; //
      contactName: string; //
      country: string; //
      lat: number; //
      lng: number; //
      locationName: string; //
      phone: string; //
      state: string; //
      addressCtd?: string;
    };
    pickupLocation: {
      address: string; //
      addressCtd?: string;
      city: string; //
      country: string; //
      firstName: string; //
      lastName: string; //
      lat: number; //
      lng: number; //
      locationName: string;
      phoneNumber: string; //
      state: string; //
    };
    preferredDeliveryMethod: { type: string };
    scheduleTime: null | string;
    serviceMetaType: string;
  };
  userCoords: {
    latitude: number;
    locationName: string;
    longitude: number;
  };
};

type OrderParams = {
  availedOfferId: string;
  discount: string|null;
  discountedUserTotal: string|null;
  distance: number;
  driverTotal: string;
  paymentIntent: string;
  promoCode: string;
  serviceCharges: string|null;
  userTotal: string|null;
  assignedDriverId: string;
  userId: string;
  minDistance: number;
  maxDistance: number;
};

export const postPickupOrder = async (
  data: PickupOrderPayload,
  params: OrderParams
) => {
  const res = await apiManager.post("/services/create-pickup", data, params);
  return res;
};

export type CurbsideOrderPayload = {
  serviceMeta: {
    deliveryInstruction: string;
    deliveryLocation: {
      address: string;
      city: string;
      contactName: string;
      country: string;
      lat: number;
      addressCtd?: string;
      lng: number;
      locationName: string;
      phone: string;
      state: string;
    };
    pickupLocation: {
      address: string;
      addressCtd?: string;
      city: string;
      country: string;
      lat: number;
      linkForConfirmation: string;
      lng: number;
      locationName: string;
      orderNum: string;
      proofOfPurchase: string;
      state: string;
      storeName: string;
    };
    preferredDeliveryMethod: { type: string };
    scheduleTime: null | string;
    serviceMetaType: string;
  };
  userCoords: {
    latitude: number;
    locationName: string;
    longitude: number;
  };
};

export const createCurbside = async (
  data: CurbsideOrderPayload,
  params: OrderParams
) => {
  const res = await apiManager.post("/services/create-curbside", data, params);
  return res;
};

export const getMaxDistance = async (scheduleTime: string | null) => {
  const res = await apiManager.get(
    `/services/get-max-distance?scheduleTime=${scheduleTime}`
  );
  return res;
};

export type InstoreOrderPayload = {
  serviceMeta: {
    deliveryInstruction: string;
    pickupInstruction?: string;
    deliveryLocation: {
      address: string;
      city: string;
      contactName: string;
      country: string;
      lat: number;
      addressCtd?: string;
      lng: number;
      locationName: string;
      phone: string;
      state: string;
    };
    pickupLocation: {
      address: string;
      addressCtd?: string;
      city: string;
      country: string;
      lat: number;

      lng: number;
      locationName: string;
      orderNum: string;
      proofOfPurchase: string;
      state: string;
      storeName: string;
    };
    preferredDeliveryMethod: { type: string };
    scheduleTime: null | string;
    serviceMetaType: string;
  };
  userCoords: {
    latitude: number;
    locationName: string;
    longitude: number;
  };
};

export const createInstoreOrder = async (
  body: InstoreOrderPayload,
  params: OrderParams
) => {
  const res = await apiManager.post("/services/create-instore", body, params);
  return res;
};

export const getDriver = async (body: {
  assignedDriverId: string;
  scheduleTime: string | null;
}) => {
  const res = await apiManager.post("/services/get-driver", body);
  return res;
};
